import { 
    CognitoUser,
    CognitoUserAttribute, 
    CognitoUserPool, 
    ISignUpResult 
} from "amazon-cognito-identity-js";

import { 
    CREATE_ORG,
    CREATE_ORG_USER,
    CREATE_USER,
    DELETE_ORG_USER_BY_ORG_EMAIL,
    GET_APP_ROLES,
    GET_ORG_USER,
    GET_ORG_USERS_WITH_ROLES,
    GET_ORG_USER_WITH_ROLES,
    GET_USER_BY_EMAIL,
    GET_USER_PROFILE,
    UPDATE_ORG_USER
} from "./queries";

export const getUserById = (client: any, userId: string) => {
    return client.query({
        query: GET_USER_PROFILE,
        variables: {
            id: userId
        },
        optimisticResponse: null
    });
}

export const getUserByEmail = (client: any, email: string) => {
    return client.query({
        query: GET_USER_BY_EMAIL,
        variables: {
            email: email
        },
        optimisticResponse: null
    });
}

export const getUsersOrgs = (client: any, userId: string) => {
    return client.query({
        query: GET_ORG_USER,
        variables: {
            user_id: userId
        },
        optimisticResponse: null
    });
}

export const createOrg = (client: any, name: string, ownerId: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        client.mutate({
            mutation: CREATE_ORG,
            variables: {
                name: name,
                ownerId: ownerId
            },
            optimisticResponse: null
        }).then((result:any) => {
            console.log(result);
            resolve(result.data.insert_syncarto_app_org.returning[0].id);
        }).catch((err:any) => {
            reject(err);
        });
    });
}

export const getOrgUsers = (client: any, orgId: string) => {
    return client.query({
        query: GET_ORG_USERS_WITH_ROLES,
        variables: {
            org_id: orgId
        },
        optimisticResponse: null
    });
}

export const getOrgUser = (client: any, orgId: string, userId: string) => {
    return client.query({
        query: GET_ORG_USER_WITH_ROLES,
        variables: {
            org_id: orgId,
            user_id: userId
        },
        optimisticResponse: null,
    });
}

export const addUserToOrg = (client: any, userId:string, roleId: number, orgId: string) => {
    return client.mutate({
        mutation: CREATE_ORG_USER,
        variables: {
            user_id: userId,
            role_id: roleId,
            org_id: orgId
        },
        optimisticResponse: null
    });  
}

export const removeUserFromOrg = (client: any, email: string, orgId: string) => {
    return client.mutate({
        mutation: DELETE_ORG_USER_BY_ORG_EMAIL,
        variables: {
            email: email,
            org_id: orgId
        },
        optimisticResponse: null
    }); 
}

export const setOrgUserRole = (client: any, orgUserId: number, userId: String, roleId: number, orgId: string) => {
    client.mutate({
        mutation: UPDATE_ORG_USER,
        variables: {
            id: orgUserId,
            role_id: roleId,  
        },
        optimisticResponse: null,
        refetchQueries: [{
            query: GET_ORG_USER_WITH_ROLES,
            variables: { 
                org_id: orgId,
                user_id: userId 
            }
        },{
        query: GET_ORG_USERS_WITH_ROLES,
        variables: {
            org_id: orgId
        }
    }]
    })
}

export const createUser = (client:any, id: string, name: string, email: string) => {
    return client.mutate({
        mutation: CREATE_USER,
        variables: {
            id: id,
            name: name,
            email: email,
        },
        optimisticResponse: null
    });  
}

export const getAppRoles = (client:any) => {
    return client.query({
        query: GET_APP_ROLES,
        variables: {},
        optimisticResponse: null
    });
}

export const createCognitoUser = (name: string, email:string, password:string): Promise<string> => {
    const poolData = {
        UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
        ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || ''
    };

    const userPool = new CognitoUserPool(poolData);
    const attributeList: CognitoUserAttribute[] = [];

    const dataEmail = {
        Name: 'email',
        Value: email
    };
    const dataName = {
        Name: 'name',
        Value: name
    };

    const attributeEmail = new CognitoUserAttribute(dataEmail);
    attributeList.push(attributeEmail);

    const attributeName = new CognitoUserAttribute(dataName);
    attributeList.push(attributeName);

    return new Promise(function (resolve, reject) {
        userPool.signUp(email, password, attributeList, [], function (err?: Error, result?: ISignUpResult) {
            if (err) {
                reject(err);
            }
            if (result) {
                resolve(result.userSub);
            } else {
                reject('No sign up result found!');
            }
        });
    });
}

export const confirmRegistration = (email: string, code: string): Promise<string> => {
    const poolData = {
        UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
        ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || ''
    };

    const userPool = new CognitoUserPool(poolData);

    const userData = {
        Username: email,
        Pool: userPool
    };

    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
        cognitoUser.confirmRegistration(code, true, function (err, result) {
            if (err) {
                console.log(err);
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}
  